import React from 'react';
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import {TextField} from "@material-ui/core";

const ChatInput = ({value, onChangeMessage, onSendMessage, sourceId}) => {
    const onKeyDown = (event) => {
        if (event.shiftKey && event.key === 'Enter') {
            return
        }
        if (event.key === 'Enter') {
            event.preventDefault();
           // document.getElementById('chatSubmitButton').click()
            onSubmitForm()
        }
    };
    const onSubmitForm = (e) => {
        e.preventDefault();
        onSendMessage()
    }
    return (
        <form id={"chatForm"}
              name={'chatForm'}
             // onSubmit={onSubmitForm}
              onKeyDown={onKeyDown}
        >
            <div style={{display: 'flex', width: '100%'}}>
                <div style={{width: '100%'}}>
                    <TextField
                        multiline
                        rows={1}
                        onChange={(e) => onChangeMessage(e.target.value)}
                        value={value.message || ""}
                        required
                        autoFocus
                        disabled={sourceId.length < 1}
                        className={'form-dynamic-withoutStyles-textarea'}
                        fullWidth
                        variant={"outlined"}
                        inputProps={{
                            style: {minHeight: 34, maxHeight: 50},
                            className: 'form-dynamic-withoutStyles-textarea-chat'
                        }}
                    />
                </div>
                <div>
                    <IconButton
                        id={"chatSubmitButton"}
                        //type={'submit'}
                      //  form={'chatForm'}
                        onClick={onSubmitForm}
                        disabled={sourceId.length < 1}
                        style={{padding: 0, height: 34, width: 34}}>
                        <Icon>
                            send
                        </Icon>
                    </IconButton>
                </div>
            </div>
        </form>
    )
};

export default ChatInput